export type TransactionStatus = 'completed' | 'pending' | 'canceled' | 'failed' | 'refunded';
export type TransactionType = 'topup' | 'withdrawal';
export type PaymentMethod = 'stripe' | 'crypto';

export interface Transaction {
    id: string;
    date: Date;
    type: TransactionType;
    paymentMethod: PaymentMethod;
    amount: number;
    status: TransactionStatus;
    details?: string;
    cardLast4?: string;
    walletAddress?: string;
}

export const formatTransactionDate = (date: Date): string => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    return `${day}.${month}.${year}`;
};

export const formatTransactionTime = (date: Date): string => {
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
};

export const maskPaymentDetails = (method: PaymentMethod, last4?: string): string => {
    if (method === 'stripe' && last4) {
        return `•••• •••• •••• ${last4}`;
    }
    if (method === 'crypto') {
        return 'Crypto Wallet';
    }
    return method.charAt(0).toUpperCase() + method.slice(1);
};

export const generateTransactionId = (): string => {
    return `TXN-${Date.now()}-${Math.random().toString(36).substr(2, 9).toUpperCase()}`;
};

export const formatCurrency = (amount: number): string => {
    return `$${amount.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
};
